import { Button } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { useDeleteRegistrationFormMutation } from "../../../queries/requestQuery";
import {
  enrollmentFormEditUrl,
  registrationFormListRoute,
} from "../../../routes/routes";

interface IProps {
  requestId: number;
  registrationFormDataChangeId: number | null;
}

export const RegistrationEnrollmentFormSection = ({
  requestId,
  registrationFormDataChangeId,
}: IProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [deleteRegistrationForm, { isLoading }] =
    useDeleteRegistrationFormMutation();

  const handleFirstButtonClick = () => {
    history.push(enrollmentFormEditUrl(requestId));
  };

  const handleSecondButtonClick = async () => {
    try {
      await deleteRegistrationForm(requestId).unwrap();
      history.push(registrationFormListRoute);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Button onClick={handleFirstButtonClick} size="sm">
        {t("request.editEnrollmentForm")}
      </Button>
      <Button
        onClick={handleSecondButtonClick}
        size="sm"
        disabled={!registrationFormDataChangeId || isLoading}
      >
        {t("request.generateNewEnrollmentForm")}
      </Button>
    </div>
  );
};
